<svg version="1.1" baseProfile="full" width="100%" xmlns="http://www.w3.org/2000/svg" class="heading-svg"
  [ngClass]="{'bg1': bg === 1,'bg2': bg === 2,'bg3': bg === 3}" preserveAspectRatio="xMidYMid meet" height="100%"
  width="100%" viewBox="0 0 380 39">
  <foreignObject y="0" height="100%" width="100%" x="20">
    <xhtml:div class="heading">
      {{title}}
    </xhtml:div>
  </foreignObject>
</svg>
